"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
exports.createMuiRadioOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            color: undefined,
            padding: "calc(" + spacing(4) + "px - 0.75rem)",
            "& .MuiSvgIcon-root": {
                borderRadius: "100%",
                fill: "transparent",
                stroke: palette.text.primary,
                transition: transitions.create(["fill", "stroke", "background-color"], {
                    duration: transitions.duration.shorter,
                }),
            },
        },
        colorPrimary: {
            "&&:hover, &&$checked:hover, &.Mui-focusVisible": {
                backgroundColor: "unset",
                boxShadow: "unset",
            },
            "&:hover .MuiSvgIcon-root": {
                stroke: "currentColor",
                fill: colorManipulator_1.fade(palette.primary.main, 0.25),
            },
            "&.Mui-focusVisible .MuiSvgIcon-root": {
                stroke: "currentColor",
                fill: colorManipulator_1.fade(palette.primary.main, 0.25),
                backgroundColor: colorManipulator_1.fade(palette.primary.main, 0.25),
            },
            "&$disabled": {
                color: palette.action.disabled,
            },
        },
        disabled: {
            "& .MuiSvgIcon-root": {
                stroke: "currentColor",
            },
        },
    });
};
//# sourceMappingURL=MuiRadio.js.map